import React, { memo, useRef, useState } from "react";

import { Document, Page, pdfjs } from "react-pdf";

// TODO: avoid using external worker, import from react-pdf/dist/esm/entry.webpack instead
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

interface Props {
  className?: string;
  file: Blob;
}

const PdfFilePreview: React.FC<Props> = ({ className, file }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [base64View, setBase64View] = useState<ArrayBuffer | null | string>(null);

  React.useEffect(() => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      setBase64View(reader.result);
    };
  }, [file]);

  React.useLayoutEffect(() => {
    const listener = () => {
      ref
        .current!.querySelectorAll(".react-pdf__Page__svg, .react-pdf__Page__svg svg")
        .forEach((node) => {
          (node as HTMLElement).style.width = "100%";
          (node as HTMLElement).style.height = "auto";
          if (ref.current!.clientHeight > 0) {
            (node as HTMLElement).style.maxHeight = `${ref.current!.clientHeight}px`;
          }
        });
    };

    const mo = new MutationObserver(listener);
    const ro = new ResizeObserver(listener);

    if (ref.current) {
      mo.observe(ref.current!, { childList: true, subtree: true });
      ro.observe(ref.current!);
    }

    return () => {
      ro.disconnect();
      mo.disconnect();
    };
  }, []);

  return (
    <div className={className} ref={ref}>
      <Document file={base64View} renderMode="svg">
        <Page pageNumber={1} />
      </Document>
    </div>
  );
};

export default memo(PdfFilePreview);
